import {URL} from './urls';
export default function getMovileurosAgents(accesToken) {
  const apiURL = URL + `/react_agents_for_filter`
  return fetch(apiURL, {
    headers: {
      'Authorization': `Bearer ${accesToken}`
    }
  })
    .then(res => res.json())
    .then(response => {
      const tempArray = [];
      if (response) {
        if (response.length) {
          response.forEach((element) => {
            tempArray.push({
              label: `${element.income_code} - ${element.name || ''} ${element.surname || ''}`.trim(),
              value: element.id,
            });
          });
        } else {
          tempArray.push({
            label: `${response.income_code} - ${response.name || ''} ${response.surname || ''}`.trim(),
            value: response.id,
          });
        }
      }
      return tempArray
    })
}
